

import React, { useEffect, useRef, useState } from "react";

import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./CoursePageAllStyles.css"
import { useSelector } from "react-redux";

import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import person1WhatYouWillDo2 from "../../../img/person1WhatYouWillDo2.svg";

import contentMan from "../../../img/contentMan.svg";
import {Minus,Activity ,ChevronLeft,ChevronUp,ChevronDown,X,Plus ,Phone,Check,Video,Play,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,BookA,GalleryHorizontal,BadgePlus,Timer,AudioLines,
    FolderHeart, Forward,Earth,ListChecks,Gift,Settings,Aperture,BetweenHorizontalStart,
    ImagePlay,Film,NotepadText,AlarmSmoke,BellElectric,CircleCheck,LayoutGrid ,CornerDownRight,BotMessageSquare,  
    LayoutPanelLeft,
    ListFilter,
    ListMusic,
    ChevronRight,
    SquareKanban,
    ShoppingBag} from 'lucide-react';
import CourseContentCard from "./CourseContentCard";
import WhatsIncludedInACourse from "./WhatsIncludedInACourse";
import CoursePageCardSubCourse from "./CoursePageCardSubCourse";

  
const CoursePageCard= ({coursePageObject})=>{ 
   
   const [deviceWidth,setDeviceWidth] = useState(false);
    const bottomDivRef = useRef(null);
    
    const bottomDivBoxRef = useRef(null);
    const bodyWidthForMobile =useRef(null)
    
    const [isVisible, setIsVisible] = useState(false);
  
    const [divHeight, setDivHeight] = useState(0);
 
useEffect(() => {
      // setVideoInPlayer(courseData?.CourseVideoLinks!=[]?courseData?.CourseVideoLinks[0]:"")
      if (bodyWidthForMobile.current) {
        let offsetWidth = bodyWidthForMobile?.current?.offsetWidth;
          setDeviceWidth(offsetWidth)
      }
      setDivHeight(bottomDivBoxRef?.current?.offsetHeight);
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true); // Set state when the div appears
          } else {
            setIsVisible(false); // Reset state if it goes out of view
          }
        },
        {
          root: null, // Observe within the viewport
          threshold: 1.0, // Trigger only when fully visible (at the bottom of the viewport)
        }
      );
  
      if (bottomDivRef.current) {
        observer.observe(bottomDivRef.current);
      }
  
      return () => {
        if (bottomDivRef.current) {
          observer.unobserve(bottomDivRef.current);
        }
      };
    }, [deviceWidth])


    const scrollableDivRef = useRef(null);

    const StarRating = ({ totalStars = 5 }) => {
      const [rating, setRating] = useState(0);
    
      const handleClick = (index) => {
        setRating(index + 1); // Update rating on click
      };
    
      return (
        <div style={{ display: "flex", gap: "2px", justifyContent: "center", alignItems: "center" ,
        marginTop:"-10px"}}>
          {[...Array(totalStars)].map((_, index) => (
            <Star
              key={index}
              filled={index < rating}
              onClick={() => handleClick(index)}
            />
          ))}
        </div>
      );
    };
    
    const Star = ({ filled, onClick }) => (
      <svg
        onClick={onClick}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        // fill={filled ? "gold" : "none"}
        fill="gold"
        stroke="gold"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        width="16px"
        height="16px"
        style={{ cursor: "pointer", transition: "fill 0.3s ease" }}
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    );
   const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    
    </div>
  );
};
 const HorizontalScroller = ({coursePageObject, items }) => {
    const scrollerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
  
    const scroll = (direction) => {
      if (scrollerRef.current) {
        const scrollAmount = 260; // Adjust scroll distance per click
        scrollerRef.current.scrollBy({
          left: direction === "left" ? -scrollAmount : scrollAmount,
          behavior: "smooth",
        });
      }
    };
     // Mouse drag handlers
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollerRef.current.offsetLeft);
    setScrollLeft(scrollerRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault(); // Prevent text selection
    const x = e.pageX - scrollerRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Adjust for sensitivity
    scrollerRef.current.scrollLeft = scrollLeft - walk;
  };


  const handleMouseUp = () => setIsDragging(false);
  const handleMouseLeave = () => setIsDragging(false);

    return (
      <div className="scroller-wrapperCoursePage" style={{background:`${coursePageObject?.milestoneCarousel?.bgColor?.color}`,
    border:` ${coursePageObject?.milestoneCarousel?.border?.borderWidth?.value+coursePageObject?.milestoneCarousel?.border?.borderWidth?.resolution} ${coursePageObject?.milestoneCarousel?.border?.borderType}  ${coursePageObject?.milestoneCarousel?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.milestoneCarousel?.borderRadius?.topLeft?.value}${coursePageObject?.milestoneCarousel?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.milestoneCarousel?.borderRadius?.topRight?.value}${coursePageObject?.milestoneCarousel?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.milestoneCarousel?.borderRadius?.bottomLeft?.value}${coursePageObject?.milestoneCarousel?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.milestoneCarousel?.borderRadius?.bottomRight?.value}${coursePageObject?.milestoneCarousel?.borderRadius?.bottomRight?.resolution}`,
}}>
        <button className="scroll-btnCoursePage left" style={{background:coursePageObject?.milestoneCarousel?.iconBgColor?.color}} onClick={() => scroll("left")}>
          <ChevronLeft   strokeWidth={2} absoluteStrokeWidth  size={30} 
                   color={coursePageObject?.milestoneCarousel?.iconColor?.color} />
        </button> 
        <div className="scrollerCoursePage" ref={scrollerRef} >
          {items.map((item, index) => (
            <div key={index} style={{display:"flex",justifyContent:"flex-start", }} onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}   >
       
            <div
className={"posRelative"  }
             style={{ margin:"0px",marginTop:"1px",background:item?.active?coursePageObject?.milestoneCarousel?.bgColor?.color:"rgba(255, 255, 255, 1) ",
                marginRight:"0px",position:"relative",borderRadius:"10px",overflow:"hidden",maxWidth:"200px",fontSize:"22px",padding:"10px",}} 
          
             
            >  <div  style={{display:"flex",justifyContent:"space-between" }}>
          <div   style={{width:"155px",marginTop:"0px",fontWeight:"999",}}  >
                   <div  className="TitleWithEllipsis coursePageTagsFont" style={{width:"150px",fontWeight:"999",display:"flex",justifyContent:"center",alignItems:"center",
                    color:coursePageObject?.milestoneCarousel?.textColor?.color
                   }}  >
                  MileStone {item?.menuOrder}  
                   </div> 
                   {/* <div align="center" className="" style={{marginTop:"20px",marginLeft:"30px"}} ><div  
                    style={{cursor:"pointer",color:"rgba(144, 202, 249,1)",left:"50px",background:"#fff",width:"120px",fontSize:"14px",height:"40px"}} 
            className="milestoneButtonInCard" >Add Content </div>
           </div> */}
                     </div>
                   
                   </div>     
                   </div>  
            </div>
          ))}


      
          
                   
        </div>
        <button className="scroll-btnCoursePage right" style={{background:coursePageObject?.milestoneCarousel?.iconBgColor?.color}} onClick={() => scroll("right")}>
        <ChevronRight   strokeWidth={2} absoluteStrokeWidth  size={30} 
                   color={coursePageObject?.milestoneCarousel?.iconColor?.color}/>
        </button>
      </div>
    );
  };

     return(<>
     
  <div style={{transform:"scale(0.9)",background:`${coursePageObject?.outerCard?.layoutBG?.color}`,
border:` ${coursePageObject?.outerCard?.border?.borderWidth?.value+coursePageObject?.outerCard?.border?.borderWidth?.resolution} ${coursePageObject?.outerCard?.border?.borderType}  ${coursePageObject?.outerCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.outerCard?.borderRadius?.topLeft?.value}${coursePageObject?.outerCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.outerCard?.borderRadius?.topRight?.value}${coursePageObject?.outerCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.outerCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.outerCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.outerCard?.borderRadius?.bottomRight?.value}${coursePageObject?.outerCard?.borderRadius?.bottomRight?.resolution}`,
            }}  >
 

 <div ref={bodyWidthForMobile} className="" style={{ height:"85vh",overflow:"auto",overflowX:"hidden", position:"relative",}} >
 {/* <div className="content-topk"></div>  */}
   




 {true?
    <div className="courseCourseCardlOuterGrid" style={{ minHeight:"85vh",overflowX:"hidden", position:"relative",

    }} >
      <div>
        <div 
       
        className={`${!isVisible?"fixed-div-courseCard1":"normal-div-last-courseCard1"}  `}
        style={{ textAlign:"left" ,padding:"0px",background:`${coursePageObject?.sidebarCard?.bgColor?.color}`,
border:` ${coursePageObject?.sidebarCard?.border?.borderWidth?.value+coursePageObject?.sidebarCard?.border?.borderWidth?.resolution} ${coursePageObject?.sidebarCard?.border?.borderType}  ${coursePageObject?.sidebarCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.sidebarCard?.borderRadius?.topLeft?.value}${coursePageObject?.sidebarCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.sidebarCard?.borderRadius?.topRight?.value}${coursePageObject?.sidebarCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.sidebarCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.sidebarCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.sidebarCard?.borderRadius?.bottomRight?.value}${coursePageObject?.sidebarCard?.borderRadius?.bottomRight?.resolution}`,
         }} // Move the div horizontally
      >
        <div   style={{width:"100px",height:"60px",
        position:"absolute",
        zIndex:"9999", top:"100px",left:"37%",textAlign:"center" ,cursor:"pointer"
        ,background:`${coursePageObject?.playerButton?.bgColor?.color}`,
border:` ${coursePageObject?.playerButton?.border?.borderWidth?.value+coursePageObject?.playerButton?.border?.borderWidth?.resolution} ${coursePageObject?.playerButton?.border?.borderType}  ${coursePageObject?.playerButton?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.playerButton?.borderRadius?.topLeft?.value}${coursePageObject?.playerButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.playerButton?.borderRadius?.topRight?.value}${coursePageObject?.playerButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.playerButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.playerButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.playerButton?.borderRadius?.bottomRight?.value}${coursePageObject?.playerButton?.borderRadius?.bottomRight?.resolution}`,
        
        }}>
          <Play strokeWidth={3}  size={35}style={{margin:"13px"}}  color={coursePageObject?.playerButton?.iconColor?.color}/>
        </div>
        <div  style={{cursor:"pointer"}}  className="product-tag-themeCoursePage coursePageTagsFont">Trending </div>
<div  style={{cursor:"pointer",width:"100%",cursor:"pointer",marginTop:"-40px"
    
   }}>
<ImageFallFB  boxShadow={``}
                  src={coursePageObject?.imageThumbnail?.src}
                  border={coursePageObject?.imageThumbnail?.border?.borderWidth?.value+coursePageObject?.imageThumbnail?.border?.borderWidth?.resolution+" "+coursePageObject?.imageThumbnail?.border?.borderType +" "+coursePageObject?.imageThumbnail?.border?.borderColor?.color}
                  width={ 100
                  }
                  aspectRatio={coursePageObject?.imageThumbnail?.aspectRatio?.value}
                  borderRadius={ coursePageObject?.imageThumbnail?.borderRadius
                  }/>
</div>

{/* const [freePaidStatus, setFreePaidStatus] =useState(courseData?.CoursePriceType)
const [CoursePublicNoEnrollment, setCoursePublicNoEnrollment] =useState(courseData?.CoursePublicNoEnrollment)
const [salePrice, setSalePrice] =useState(courseData?.salePrice)
const [regularPrice, setRegularPrice] =useState(courseData?.regularPrice) */}
<div style={{cursor:"pointer",padding:"5px",}} >{true?
<div className="themeCoursePage" style={{display: "flex",padding:"5px",marginTop:"5px",
    flexDirection: "row",background:`${coursePageObject?.priceCard?.bgColor?.color}`,
border:` ${coursePageObject?.priceCard?.border?.borderWidth?.value+coursePageObject?.priceCard?.border?.borderWidth?.resolution} ${coursePageObject?.priceCard?.border?.borderType}  ${coursePageObject?.priceCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.priceCard?.borderRadius?.topLeft?.value}${coursePageObject?.priceCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.priceCard?.borderRadius?.topRight?.value}${coursePageObject?.priceCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.priceCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.priceCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.priceCard?.borderRadius?.bottomRight?.value}${coursePageObject?.priceCard?.borderRadius?.bottomRight?.resolution}`,
        
     }}>
<div className="themeCoursePage coursePageTitleFont" style={{fontSize:"35px",color:coursePageObject?.priceCard?.textColor?.color}}> ₹499.00</div>
<div className="themeCoursePage strikethrough coursePageSubTitleFont" style={{fontSize:"18px",color:coursePageObject?.priceCard?.subTextColor?.color}}>
   ₹1499.00 </div>
   <div className="themeCoursePage" style={{fontSize:"13px",color:"#777",marginRight:"15px",float:"right"}}>
    </div>

</div>:<div className="themeCoursePage" >
<div className="themeCoursePage coursePageTitleFont " style={{fontSize:"28px",color:coursePageObject?.priceCard?.textColor?.color}}>  Free</div>
</div>}
</div>

{
  //for mobile Bottom Card
}
<div  className="BottomCardXsCourse"><div  className="BottomCardXsCourseInn">
{true?
<div className="themeCoursePage" style={{padding:"5px",background:`${coursePageObject?.priceCard?.bgColor?.color}`,
border:` ${coursePageObject?.priceCard?.border?.borderWidth?.value+coursePageObject?.priceCard?.border?.borderWidth?.resolution} ${coursePageObject?.priceCard?.border?.borderType}  ${coursePageObject?.priceCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.priceCard?.borderRadius?.topLeft?.value}${coursePageObject?.priceCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.priceCard?.borderRadius?.topRight?.value}${coursePageObject?.priceCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.priceCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.priceCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.priceCard?.borderRadius?.bottomRight?.value}${coursePageObject?.priceCard?.borderRadius?.bottomRight?.resolution}`,
        
     }}>
<div className="themeCoursePage coursePageTitleFont" style={{fontSize:"26px",color:coursePageObject?.priceCard?.textColor?.color}}> ₹499.00</div>
<div className="themeCoursePage strikethrough coursePageSubTitleFont" style={{fontSize:"14px",color:coursePageObject?.priceCard?.subTextColor?.color,marginTop:"-8px"}}>
   ₹1499.00 </div>
   
</div>:<div className="themeCoursePage" >
<div className="themeCoursePage coursePageTitleFont" style={{fontSize:"28px",color:coursePageObject?.priceCard?.textColor?.color}}>  Free</div>
</div>}
{true?
<div className="themeCoursePage"  style={{fontSize:"22px",color:"#fff",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"29px",background:`${coursePageObject?.secondaryButton?.bgColor?.color}`,
border:` ${coursePageObject?.secondaryButton?.border?.borderWidth?.value+coursePageObject?.secondaryButton?.border?.borderWidth?.resolution} ${coursePageObject?.secondaryButton?.border?.borderType}  ${coursePageObject?.secondaryButton?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.secondaryButton?.borderRadius?.topLeft?.value}${coursePageObject?.secondaryButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.secondaryButton?.borderRadius?.topRight?.value}${coursePageObject?.secondaryButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.secondaryButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.secondaryButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.secondaryButton?.borderRadius?.bottomRight?.value}${coursePageObject?.secondaryButton?.borderRadius?.bottomRight?.resolution}`,
 }}>
  <div className="themeCoursePage coursePageButtonFont"  style={{margin:"0px",color:coursePageObject?.secondaryButton?.textColor?.color}}>Buy Now</div></div>
  // :courseData?.CoursePublicNoEnrollment=="Yes"?
  // <div className="themeCoursePage"  style={{fontSize:"22px",color:"#fff",border:"1px solid #958FDA",
  //   borderRadius:"5px",margin:"13px",textAlign:"center",height:"29px",background:"#958FDA"}}>
  //    <div className="themeCoursePage"  style={{margin:"0px"}}>Start Now</div></div>:
  //    <div className="themeCoursePage"  style={{fontSize:"22px",color:"#fff",border:"1px solid #958FDA",
  //   borderRadius:"5px",margin:"13px",textAlign:"center",height:"29px",background:"#958FDA"}}>
  //    <div className="themeCoursePage"  style={{margin:"0px"}}>Enrol Now</div></div>
     :""}
  </div></div>

<div >
   {/* {courseData?.CoursePriceType=="Free"&&courseData?.CoursePublicNoEnrollment=="Yes"? <span className="themeCoursePage"
      style={{fontSize:"10px",color:"rgba(255,114,94,0.9)",display: "flex",
    flexDirection: "row"}}><Timer  size={22} color="rgba(255,114,94,0.9)"/> 
   <span className="themeCoursePage">No Enrollment Required</span></span> :""} */}
 
     {true? <div className=""
      style={{fontSize:"14px",paddingLeft:"10px",paddingTop:"10px",margin:"10px",
        background:`${coursePageObject?.priceValidityCard?.bgColor?.color}`,
border:` ${coursePageObject?.priceValidityCard?.border?.borderWidth?.value+coursePageObject?.priceValidityCard?.border?.borderWidth?.resolution} ${coursePageObject?.priceValidityCard?.border?.borderType}  ${coursePageObject?.priceValidityCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.priceValidityCard?.borderRadius?.topLeft?.value}${coursePageObject?.priceValidityCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.priceValidityCard?.borderRadius?.topRight?.value}${coursePageObject?.priceValidityCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.priceValidityCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.priceValidityCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.priceValidityCard?.borderRadius?.bottomRight?.value}${coursePageObject?.priceValidityCard?.borderRadius?.bottomRight?.resolution}`,
        display: "flex",
    flexDirection: "row"}}><Timer  size={22} color={coursePageObject?.priceValidityCard?.iconColor?.color}/> 
   <span className="themeCoursePage coursePageSubTitleFont" style={{color:coursePageObject?.priceValidityCard?.textColor?.color,}}> Course Validity:Lifetime</span></div> :""}
 
  </div>
  {true?<div><div className="themeCoursePage "  style={{
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px", background:`${coursePageObject?.primaryButton?.bgColor?.color}`,
border:` ${coursePageObject?.primaryButton?.border?.borderWidth?.value+coursePageObject?.primaryButton?.border?.borderWidth?.resolution} ${coursePageObject?.primaryButton?.border?.borderType}  ${coursePageObject?.primaryButton?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.primaryButton?.borderRadius?.topLeft?.value}${coursePageObject?.primaryButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.primaryButton?.borderRadius?.topRight?.value}${coursePageObject?.primaryButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.primaryButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.primaryButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.primaryButton?.borderRadius?.bottomRight?.value}${coursePageObject?.primaryButton?.borderRadius?.bottomRight?.resolution}`,
    }}>
  <div className="themeCoursePage coursePageButtonFont"  style={{margin:"0px",fontSize:"16px",color:coursePageObject?.primaryButton?.textColor?.color,}}>Add To Cart</div></div>
  <div className="themeCoursePage"  style={{fontSize:"16px",color:"#fff",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:`${coursePageObject?.secondaryButton?.bgColor?.color}`,
border:` ${coursePageObject?.secondaryButton?.border?.borderWidth?.value+coursePageObject?.secondaryButton?.border?.borderWidth?.resolution} ${coursePageObject?.secondaryButton?.border?.borderType}  ${coursePageObject?.secondaryButton?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.secondaryButton?.borderRadius?.topLeft?.value}${coursePageObject?.secondaryButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.secondaryButton?.borderRadius?.topRight?.value}${coursePageObject?.secondaryButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.secondaryButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.secondaryButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.secondaryButton?.borderRadius?.bottomRight?.value}${coursePageObject?.secondaryButton?.borderRadius?.bottomRight?.resolution}`,
   }}>
  <div className="themeCoursePage coursePageButtonFont"  style={{margin:"0px",color:coursePageObject?.secondaryButton?.textColor?.color,}}>Buy Now</div></div></div>
//   :courseData?.CoursePublicNoEnrollment=="Yes"?
//   <div className="themeCoursePage"  style={{fontSize:"16px",color:"#958FDA",border:"1px solid #958FDA",
//     borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px"}}>
//      <div className="themeCoursePage"  style={{margin:"0px"}}>Start Now</div></div>:<div className="themeCoursePage"  style={{fontSize:"16px",color:"#fff",border:"1px solid #958FDA",
//  borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:"#958FDA"}}>
//   <div className="themeCoursePage"  style={{margin:"0px"}}>Enrol Now</div></div>
  :""}

  <div className="themeCoursePage grid2080CoursePage"  style={{
  
 borderRadius:"25px",margin:"13px",marginTop:"30px",height:"44px",background:`${coursePageObject?.giftCourse?.bgColor?.color}`,
border:` ${coursePageObject?.giftCourse?.border?.borderWidth?.value+coursePageObject?.giftCourse?.border?.borderWidth?.resolution} ${coursePageObject?.giftCourse?.border?.borderType}  ${coursePageObject?.giftCourse?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.giftCourse?.borderRadius?.topLeft?.value}${coursePageObject?.giftCourse?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.giftCourse?.borderRadius?.topRight?.value}${coursePageObject?.giftCourse?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.giftCourse?.borderRadius?.bottomLeft?.value}${coursePageObject?.giftCourse?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.giftCourse?.borderRadius?.bottomRight?.value}${coursePageObject?.giftCourse?.borderRadius?.bottomRight?.resolution}`,
 }}>
  <div style={{background:`${coursePageObject?.giftCourse?.iconBgColor?.color}`,width:"50px",height:"50px",borderRadius:"50%",padding:"0px"}} >
  <Gift strokeWidth={2} absoluteStrokeWidth  size={27} style={{margin:"11px"}} color={coursePageObject?.giftCourse?.iconColor?.color} />  </div>
  <div   >
    <div className="themeCoursePage coursePageTitleFont"   style={{margin:"0px",fontSize:"16px",color:coursePageObject?.giftCourse?.textColor?.color}}>Gift this course</div>
  <div className="themeCoursePage  coursePageSubTitleFont"  style={{marginTop:"-13px",fontSize:"12px",color:coursePageObject?.giftCourse?.subTextColor?.color,fontWeight:"500"}}
  >Send this course as  gift to your friends</div></div></div>
<div style={{padding:"10px"}} ref={bottomDivBoxRef}>

   


</div>

</div></div>
<div className=" " style={{padding:"10px",background:`${coursePageObject?.mainCard?.layoutBG?.color}`,
border:` ${coursePageObject?.mainCard?.border?.borderWidth?.value+coursePageObject?.mainCard?.border?.borderWidth?.resolution} ${coursePageObject?.mainCard?.border?.borderType}  ${coursePageObject?.mainCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.mainCard?.borderRadius?.topLeft?.value}${coursePageObject?.mainCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.mainCard?.borderRadius?.topRight?.value}${coursePageObject?.mainCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.mainCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.mainCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.mainCard?.borderRadius?.bottomRight?.value}${coursePageObject?.mainCard?.borderRadius?.bottomRight?.resolution}`,
 }} ><div style={{cursor:"pointer",background:`${coursePageObject?.mainTitle?.bgColor?.color}`,
border:` ${coursePageObject?.mainTitle?.border?.borderWidth?.value+coursePageObject?.mainTitle?.border?.borderWidth?.resolution} ${coursePageObject?.mainTitle?.border?.borderType}  ${coursePageObject?.mainTitle?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.mainTitle?.borderRadius?.topLeft?.value}${coursePageObject?.mainTitle?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.mainTitle?.borderRadius?.topRight?.value}${coursePageObject?.mainTitle?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.mainTitle?.borderRadius?.bottomLeft?.value}${coursePageObject?.mainTitle?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.mainTitle?.borderRadius?.bottomRight?.value}${coursePageObject?.mainTitle?.borderRadius?.bottomRight?.resolution}`,
 }} >

<div className="themeCoursePage courseTitleFont coursePageTitleFont" style={{color:`${coursePageObject?.mainTitle?.textColor?.color}`,}}
>Direct your energy where it counts, stay calm under pressure, and let clarity shape decisive action.
  
 </div>
 </div>
<div className="themeCoursePage courseCat coursePageSubTitleFont" style={{marginTop:"15px",display: "flex",
    flexDirection: "row",}}>
  <div className="themeCoursePage" style={{display: "flex",
    justifyContent:"center",alignItems:"center",background:`${coursePageObject?.categoryTag?.bgColor?.color}`,
border:` ${coursePageObject?.categoryTag?.border?.borderWidth?.value+coursePageObject?.categoryTag?.border?.borderWidth?.resolution} ${coursePageObject?.categoryTag?.border?.borderType}  ${coursePageObject?.categoryTag?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.categoryTag?.borderRadius?.topLeft?.value}${coursePageObject?.categoryTag?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.categoryTag?.borderRadius?.topRight?.value}${coursePageObject?.categoryTag?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.categoryTag?.borderRadius?.bottomLeft?.value}${coursePageObject?.categoryTag?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.categoryTag?.borderRadius?.bottomRight?.value}${coursePageObject?.categoryTag?.borderRadius?.bottomRight?.resolution}`,
 }}>
  In <span className=" catUndrlineCoursePage coursePageTagsFont" style={{paddingLeft:"15px",color:`${coursePageObject?.categoryTag?.textColor?.color}`,}}> Blender </span></div><div></div></div>

<div className="themeCoursePage" style={{display: "flex",
    flexDirection: "row",}}>
<div    onClick={()=>{}} className=" coursePageTagsFont " 
  style={{display: "flex",gap:"5px",justifyContent:"center",alignItems:"center",padding:"5px 15px",marginRight:"10px",fontSize:"17px",fontWeight:"999",cursor:"pointer",color:coursePageObject?.mainStatusTag?.iconColor?.color,background:`${coursePageObject?.mainStatusTag?.bgColor?.color}`,
border:` ${coursePageObject?.mainStatusTag?.border?.borderWidth?.value+coursePageObject?.mainStatusTag?.border?.borderWidth?.resolution} ${coursePageObject?.mainStatusTag?.border?.borderType}  ${coursePageObject?.mainStatusTag?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.mainStatusTag?.borderRadius?.topLeft?.value}${coursePageObject?.mainStatusTag?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.mainStatusTag?.borderRadius?.topRight?.value}${coursePageObject?.mainStatusTag?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.mainStatusTag?.borderRadius?.bottomLeft?.value}${coursePageObject?.mainStatusTag?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.mainStatusTag?.borderRadius?.bottomRight?.value}${coursePageObject?.mainStatusTag?.borderRadius?.bottomRight?.resolution}`,
  }}>
<AudioLines size={26} color={coursePageObject?.mainStatusTag?.iconColor?.color }strokeWidth={3} /> Trending</div>
<StarRating totalStars={5}  /> <div className="themeCoursePage coursePageTagsFont"
 style={{padding:"15px",fontSize:"14px",color:"#999999",fontWeight:"600"}}>4.5 (459 Ratings)</div>
</div>


<div className="themeCoursePage afterTitleBadgesLeft" style={{}}>
  

<div     className="themeCoursePage " style={{marginRight:"15px",fontSize:"16px",height:"16px",fontWeight:"999",display: "flex",
    flexDirection: "row",cursor:"pointer",background:`${coursePageObject?.languageTag?.bgColor?.color}`,
border:` ${coursePageObject?.languageTag?.border?.borderWidth?.value+coursePageObject?.languageTag?.border?.borderWidth?.resolution} ${coursePageObject?.languageTag?.border?.borderType}  ${coursePageObject?.languageTag?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.languageTag?.borderRadius?.topLeft?.value}${coursePageObject?.languageTag?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.languageTag?.borderRadius?.topRight?.value}${coursePageObject?.languageTag?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.languageTag?.borderRadius?.bottomLeft?.value}${coursePageObject?.languageTag?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.languageTag?.borderRadius?.bottomRight?.value}${coursePageObject?.languageTag?.borderRadius?.bottomRight?.resolution}`,
 }}>
<Earth size={26} color={coursePageObject?.languageTag?.iconColor?.color} strokeWidth={3} /> 
<div  className="themeCoursePage coursePageTagsFont"
style={{color:`${coursePageObject?.languageTag?.textColor?.color}`,}}>Hindi</div></div>
  <div className="themeCoursePage"  style={{fontSize:"14px",
 borderRadius:"25px",margin:"0px",marginTop:"2px",textAlign:"center",height:"10px",
 cursor:"pointer",background:`${coursePageObject?.typeTag?.bgColor?.color}`,
border:` ${coursePageObject?.typeTag?.border?.borderWidth?.value+coursePageObject?.typeTag?.border?.borderWidth?.resolution} ${coursePageObject?.typeTag?.border?.borderType}  ${coursePageObject?.typeTag?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.typeTag?.borderRadius?.topLeft?.value}${coursePageObject?.typeTag?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.typeTag?.borderRadius?.topRight?.value}${coursePageObject?.typeTag?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.typeTag?.borderRadius?.bottomLeft?.value}${coursePageObject?.typeTag?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.typeTag?.borderRadius?.bottomRight?.value}${coursePageObject?.typeTag?.borderRadius?.bottomRight?.resolution}`,
 }}>
  <div className="themeCoursePage coursePageTagsFont"  style={{marginTop:"-3px",color:`${coursePageObject?.typeTag?.textColor?.color}`,}}>Difficult</div></div>
 <div className="themeCoursePage coursePageTagsFont"
 style={{padding:"15px",fontSize:"14px",color:"#999999",fontWeight:"500"}}>Last Updated On : </div>
 <div  className="themeCoursePage coursePageTagsFont"style={{color:"#999999"}}>20 Sept 2024</div>
 <div  style={{fontSize:"16px",padding:"10px",fontWeight:"999",display: "flex",gap:"10px",
    justifyContent:"center",alignItems:"center",background:`${coursePageObject?.shareIcon?.iconBgColor?.color}`,
    border:` ${coursePageObject?.shareIcon?.border?.borderWidth?.value+coursePageObject?.shareIcon?.border?.borderWidth?.resolution} ${coursePageObject?.shareIcon?.border?.borderType}  ${coursePageObject?.shareIcon?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.shareIcon?.borderRadius?.topLeft?.value}${coursePageObject?.shareIcon?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.shareIcon?.borderRadius?.topRight?.value}${coursePageObject?.shareIcon?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.shareIcon?.borderRadius?.bottomLeft?.value}${coursePageObject?.shareIcon?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.shareIcon?.borderRadius?.bottomRight?.value}${coursePageObject?.shareIcon?.borderRadius?.bottomRight?.resolution}`,
}}><span  className=" shareWishlistTextCoursePage coursePageTagsFont">Share</span> <Forward strokeWidth={3} absoluteStrokeWidth size={22} color={coursePageObject?.shareIcon?.iconColor?.color}/>
</div>
<div  style={{fontSize:"16px",padding:"10px",marginLeft:"10px",fontWeight:"999",display: "flex",gap:"10px",
     justifyContent:"center",alignItems:"center",background:`${coursePageObject?.shareIcon?.iconBgColor?.color}`,border:` ${coursePageObject?.shareIcon?.border?.borderWidth?.value+coursePageObject?.shareIcon?.border?.borderWidth?.resolution} ${coursePageObject?.shareIcon?.border?.borderType}  ${coursePageObject?.shareIcon?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.shareIcon?.borderRadius?.topLeft?.value}${coursePageObject?.shareIcon?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.shareIcon?.borderRadius?.topRight?.value}${coursePageObject?.shareIcon?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.shareIcon?.borderRadius?.bottomLeft?.value}${coursePageObject?.shareIcon?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.shareIcon?.borderRadius?.bottomRight?.value}${coursePageObject?.shareIcon?.borderRadius?.bottomRight?.resolution}`,
}}><span  className=" shareWishlistTextCoursePage coursePageTagsFont">Wishlist </span>
 <FolderHeart  strokeWidth={3} absoluteStrokeWidth  size={22} color={coursePageObject?.shareIcon?.iconColor?.color}/>
 </div>
</div>
<div className="themeCoursePage "  style={{background:`${coursePageObject?.whatsApproxIncluded?.bgColor?.color}`,
    border:` ${coursePageObject?.whatsApproxIncluded?.border?.borderWidth?.value+coursePageObject?.whatsApproxIncluded?.border?.borderWidth?.resolution} ${coursePageObject?.whatsApproxIncluded?.border?.borderType}  ${coursePageObject?.whatsApproxIncluded?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.whatsApproxIncluded?.borderRadius?.topLeft?.value}${coursePageObject?.whatsApproxIncluded?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.whatsApproxIncluded?.borderRadius?.topRight?.value}${coursePageObject?.whatsApproxIncluded?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.whatsApproxIncluded?.borderRadius?.bottomLeft?.value}${coursePageObject?.whatsApproxIncluded?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.whatsApproxIncluded?.borderRadius?.bottomRight?.value}${coursePageObject?.whatsApproxIncluded?.borderRadius?.bottomRight?.resolution}`,
}}>
<div className="themeCoursePage coursePageTitleFont"   style={{margin:"0px",fontSize:"26px",color:coursePageObject?.whatsApproxIncluded?.textColor?.color ,fontWeight:"800"}}>
     This Course Includes Approx- </div>
   
<div className="coursePageWhatsIncluded"  style={{marginTop:"20px",
   position:"relative"}}>
<WhatsIncludedInACourse index={1}  iconColor={coursePageObject?.whatsApproxIncluded?.iconColor?.color} textColor={coursePageObject?.whatsApproxIncluded?.subTextColor?.color}
          contentType={"Videos Included in this Course"} no={1} id={1} totalNumber={10} status={true} 
          contentIcon={"Video"}   />
<WhatsIncludedInACourse index={1}  iconColor={coursePageObject?.whatsApproxIncluded?.iconColor?.color} textColor={coursePageObject?.whatsApproxIncluded?.subTextColor?.color}
          contentType={"Quizzes Included in this Course"} no={1} id={1} totalNumber={10} status={true} 
          contentIcon={"MonitorPlay"}   />
<WhatsIncludedInACourse index={1}  iconColor={coursePageObject?.whatsApproxIncluded?.iconColor?.color} textColor={coursePageObject?.whatsApproxIncluded?.subTextColor?.color}
          contentType={"Mocks Included in this Course"} no={1} id={1} totalNumber={10} status={true} 
          contentIcon={"GalleryHorizontal"}   /></div>
          </div>

{/* 
{courseData?.MaterialIncluded?Object.values(courseData?.MaterialIncluded).map((item, index) => 
        (<div style={{cursor:"pointer"}} ><WhatsIncludedInACourse index={index} key={item.id} 
          contentType={item.contentType} no={item.no} id={item.id} totalNumber={item.totalNumber} status={item.status} 
          contentIcon={item.contentIcon}   /></div>)):'' } */}
<div className="themeCoursePage"  style={{marginTop:"50px",marginBottom:"50px",
  minHeight:"190px",borderRadius:"25px",position:"relative",background:`${coursePageObject?.whatWillYouLearn?.bgColor?.color}`,
    border:` ${coursePageObject?.whatWillYouLearn?.border?.borderWidth?.value+coursePageObject?.whatWillYouLearn?.border?.borderWidth?.resolution} ${coursePageObject?.whatWillYouLearn?.border?.borderType}  ${coursePageObject?.whatWillYouLearn?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.whatWillYouLearn?.borderRadius?.topLeft?.value}${coursePageObject?.whatWillYouLearn?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.whatWillYouLearn?.borderRadius?.topRight?.value}${coursePageObject?.whatWillYouLearn?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.whatWillYouLearn?.borderRadius?.bottomLeft?.value}${coursePageObject?.whatWillYouLearn?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.whatWillYouLearn?.borderRadius?.bottomRight?.value}${coursePageObject?.whatWillYouLearn?.borderRadius?.bottomRight?.resolution}`,
}}>
<div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",background:coursePageObject?.whatWillYouLearn?.iconBgColor?.color}}>
{coursePageObject?.whatWillYouLearn?.imageStatus?<img    className="CourseSideStickImg" src={person1WhatYouWillDo2} 
        alt="selected Img"
   style={{cursor:"pointer",
    
   }}/>:""}
</div>
<div className="themeCoursePage courseContentTitleFontCoursePage coursePageTitleFont" style={{color:coursePageObject?.whatWillYouLearn?.textColor?.color }}>What you'll learn</div>
<div className=" courseWhatWillearnTextCoursePage">
  
      <div  className="courseWhatWillearnIcon" style={{background:coursePageObject?.whatWillYouLearn?.iconBgColor?.color,margin:"10px",marginTop:"30px",padding:"10px",borderRadius:"15px"}}>
      <ListChecks strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.whatWillYouLearn?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",color:coursePageObject?.whatWillYouLearn?.subTextColor?.color,fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon" style={{background:coursePageObject?.whatWillYouLearn?.iconBgColor?.color,margin:"10px",marginTop:"30px",padding:"10px",borderRadius:"15px"}}>
      <ListChecks strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.whatWillYouLearn?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",color:coursePageObject?.whatWillYouLearn?.subTextColor?.color,fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div><div  className="courseWhatWillearnIcon" style={{background:coursePageObject?.whatWillYouLearn?.iconBgColor?.color,margin:"10px",marginTop:"30px",padding:"10px",borderRadius:"15px"}}>
      <ListChecks strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.whatWillYouLearn?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",color:coursePageObject?.whatWillYouLearn?.subTextColor?.color,fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
      </div>
</div>
</div>
<div className="themeCoursePage"  style={{marginTop:"50px",overflow:"hidden",
  minHeight:"190px",position:"relative"
  ,background:`${coursePageObject?.subCourseCardOuter?.bgColor?.color}`,
    border:` ${coursePageObject?.subCourseCardOuter?.border?.borderWidth?.value+coursePageObject?.subCourseCardOuter?.border?.borderWidth?.resolution} ${coursePageObject?.subCourseCardOuter?.border?.borderType}  ${coursePageObject?.subCourseCardOuter?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.subCourseCardOuter?.borderRadius?.topLeft?.value}${coursePageObject?.subCourseCardOuter?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.subCourseCardOuter?.borderRadius?.topRight?.value}${coursePageObject?.subCourseCardOuter?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.subCourseCardOuter?.borderRadius?.bottomLeft?.value}${coursePageObject?.subCourseCardOuter?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.subCourseCardOuter?.borderRadius?.bottomRight?.value}${coursePageObject?.subCourseCardOuter?.borderRadius?.bottomRight?.resolution}`,
}}>
<div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",background:coursePageObject?.subCourseCardOuter?.iconBgColor?.color}}>
{coursePageObject?.subCourseCardOuter?.imageStatus?<img    className="CourseSideStickImgTw" src={contentMan} 
        alt="selected Img"
   style={{cursor:"pointer",
    
   }}/>:""}
</div>
<div className="themeCoursePage courseContentTitleFontTwoCoursePage coursePageHeaderFont"style={{marginBottom:"20px",color:coursePageObject?.subCourseCardOuter?.textColor?.color}}>Sub - Courses</div>
<div  style={{display:"flex",top:"0px",cursor:"pointer",justifyContent:"space-between" ,width:"100%"}} 
          > 
           
            <div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start",position:"relative",gap:"10px"}}> 
                       <div  style={{padding:"5px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.subCourseCardOuter?.iconBgColor?.color}`}}> 
                         <ListChecks strokeWidth={1}  size={20}    color={coursePageObject?.subCourseCardOuter?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.subCourseCardOuter?.subTextColor?.color}}> 5  Milestones</div>
                           </div><div style={{padding:"5px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.subCourseCardOuter?.iconBgColor?.color}`}}> 
                         <BellElectric strokeWidth={1}  size={20}    color={coursePageObject?.subCourseCardOuter?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.subCourseCardOuter?.subTextColor?.color}}> 5  Sections</div>
                           </div><div  style={{padding:"5px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.subCourseCardOuter?.iconBgColor?.color}`}}> 
                         <ImagePlay strokeWidth={1}  size={20}    color={coursePageObject?.subCourseCardOuter?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.subCourseCardOuter?.subTextColor?.color}}> 5  Chapters</div>
                           </div>
                   </div>
           </div>
<div className=" " style={{marginTop:"0px"}}>

<div className="themeCoursePage gridForCoursePageFiftyFifty"  style={{marginTop:"20px",
    }}>


<CoursePageCardSubCourse coursePageObject={coursePageObject} />

<CoursePageCardSubCourse coursePageObject={coursePageObject} />

<CoursePageCardSubCourse coursePageObject={coursePageObject} />



</div>



</div>

  </div>


  
 <div style={{marginTop:"30px",borderRadius:"15px",padding:"10px",paddingBottom:"40px",background:`${coursePageObject?.skills?.bgColor?.color}`,
    border:` ${coursePageObject?.skills?.border?.borderWidth?.value+coursePageObject?.skills?.border?.borderWidth?.resolution} ${coursePageObject?.skills?.border?.borderType}  ${coursePageObject?.skills?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.skills?.borderRadius?.topLeft?.value}${coursePageObject?.skills?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.skills?.borderRadius?.topRight?.value}${coursePageObject?.skills?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.skills?.borderRadius?.bottomLeft?.value}${coursePageObject?.skills?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.skills?.borderRadius?.bottomRight?.value}${coursePageObject?.skills?.borderRadius?.bottomRight?.resolution}`,
}} >
    <div className="themeCoursePage grid2080CoursePage"  style={{
    borderRadius:"25px",margin:"3px"}}>
    <div style={{background:`${coursePageObject?.skills?.iconBgColor?.color}`,width:"56px",height:"56px",borderRadius:"50%",padding:"0px",display:"flex",justifyContent:"center",alignItems:"center"}} >
    <SquareKanban strokeWidth={4} absoluteStrokeWidth  size={30} style={{margin:"8px",marginTop:"10px"}} color={coursePageObject?.skills?.icon2Color?.color} />  </div>
    <div   >
    </div></div>
  <div><div   >
      <div className="themeCoursePage coursePageTitleFont"   style={{margin:"0px",fontSize:"32px",fontWeight:"800",color:coursePageObject?.skills?.textColor?.color}}>
        Skills </div>  
   
<div className=" gridForCoursePageFiftyFifty"  style={{marginTop:"10px",overflow:"hidden",
    minHeight:"190px",position:"relative"}}>

      <div  className="courseWhatWillearnIcon"style={{background:coursePageObject?.skills?.icon2BgColor?.color,margin:"10px",marginTop:"20px",padding:"10px",borderRadius:"15px"}}>
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.skills?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont "
 style={{fontSize:"14px",color:coursePageObject?.skills?.subTextColor?.color,fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon"style={{background:coursePageObject?.skills?.icon2BgColor?.color,margin:"10px",marginTop:"20px",padding:"10px",borderRadius:"15px"}}>
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.skills?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",color:coursePageObject?.skills?.subTextColor?.color,fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div><div  className="courseWhatWillearnIcon"style={{background:coursePageObject?.skills?.icon2BgColor?.color,margin:"10px",marginTop:"20px",padding:"10px",borderRadius:"15px"}}>
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.skills?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",color:coursePageObject?.skills?.subTextColor?.color,fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
</div>


  
    </div> 
   
    </div>
    
  
      </div>
    </div>
<div className="themeCoursePage"  style={{marginTop:"20px",overflow:"hidden",
  minHeight:"190px",borderRadius:"25px",position:"relative",background:`${coursePageObject?.contentOuter?.bgColor?.color}`,
    border:` ${coursePageObject?.contentOuter?.border?.borderWidth?.value+coursePageObject?.contentOuter?.border?.borderWidth?.resolution} ${coursePageObject?.contentOuter?.border?.borderType}  ${coursePageObject?.contentOuter?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.contentOuter?.borderRadius?.topLeft?.value}${coursePageObject?.contentOuter?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.contentOuter?.borderRadius?.topRight?.value}${coursePageObject?.contentOuter?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.contentOuter?.borderRadius?.bottomLeft?.value}${coursePageObject?.contentOuter?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.contentOuter?.borderRadius?.bottomRight?.value}${coursePageObject?.contentOuter?.borderRadius?.bottomRight?.resolution}`,
}}>
<div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",background:`${coursePageObject?.contentOuter?.iconBgColor?.color}`}}>
{coursePageObject?.contentOuter?.imageStatus?<img    className="CourseSideStickImgTw" src={contentMan} 
        alt="selected Img"
   style={{cursor:"pointer" }}/>:""}
</div>
<h2 className="coursePageHeaderFont" style={{color:coursePageObject?.contentOuter?.textColor?.color }}>Sub Course  1</h2>
  <div  style={{display:"flex",top:"0px",cursor:"pointer",justifyContent:"space-between" ,width:"100%"}} 
          > 
           
            <div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start",position:"relative",gap:"10px"}}> 
                       <div className="" style={{padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.contentOuter?.iconBgColor?.color}`}}> 
                         <ListChecks strokeWidth={1}  size={20}    color={coursePageObject?.contentOuter?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.contentOuter?.subTextColor?.color}}> 5  Milestones</div>
                           </div><div className="" style={{padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.contentOuter?.iconBgColor?.color}`}}> 
                         <BellElectric strokeWidth={1}  size={20}    color={coursePageObject?.contentOuter?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.contentOuter?.subTextColor?.color}}> 5  Sections</div>
                           </div><div className="" style={{padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.contentOuter?.iconBgColor?.color}`}}> 
                         <ImagePlay strokeWidth={1}  size={20}    color={coursePageObject?.contentOuter?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.contentOuter?.subTextColor?.color}}> 5  Chapters</div>
                           </div>
                   </div>
           </div>
<div className="themeCoursePage courseContentTitleFontTwoCoursePage coursePageTitleFont"style={{marginBottom:"20px",
  color:coursePageObject?.contentOuter?.subTextColor?.color
}}>Course Content</div>
<HorizontalScroller coursePageObject={coursePageObject} items={[{menuOrder:1,active:true},{menuOrder:2},{menuOrder:3},{menuOrder:4}]} />

<div className=" " style={{marginTop:"150px"}}>


<CourseContentCard coursePageObject={coursePageObject} />




</div>

<div className="contentsRemainingButtonOuter">
  <div className="themeCoursePage contentsRemainingButtonOuter"  style={{fontSize:"16px",
  fontWeight:"700",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:`${coursePageObject?.moreSectionsBtn?.bgColor?.color}`,
    border:` ${coursePageObject?.moreSectionsBtn?.border?.borderWidth?.value+coursePageObject?.moreSectionsBtn?.border?.borderWidth?.resolution} ${coursePageObject?.moreSectionsBtn?.border?.borderType}  ${coursePageObject?.moreSectionsBtn?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.moreSectionsBtn?.borderRadius?.topLeft?.value}${coursePageObject?.moreSectionsBtn?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.moreSectionsBtn?.borderRadius?.topRight?.value}${coursePageObject?.moreSectionsBtn?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.moreSectionsBtn?.borderRadius?.bottomLeft?.value}${coursePageObject?.moreSectionsBtn?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.moreSectionsBtn?.borderRadius?.bottomRight?.value}${coursePageObject?.moreSectionsBtn?.borderRadius?.bottomRight?.resolution}`,
}}>
  <Plus  strokeWidth={3}   absoluteStrokeWidth  size={25}  color={coursePageObject?.moreSectionsBtn?.textColor?.color}/> <div className="themeCoursePage"  style={{margin:"0px"}}> 
    <div  className="themeCoursePage coursePageButtonFont" style={{marginTop:"-5px", color:coursePageObject?.moreSectionsBtn?.textColor?.color}}>  6 More Sections</div></div></div>

  </div>
  </div>

  
     <div className="themeCoursePage"  style={{marginTop:"50px",marginBottom:"30px",paddingBottom:"25px",overflow:"hidden",
  minHeight:"190px",borderRadius:"25px",position:"relative",
  background:`${coursePageObject?.targetAudience?.bgColor?.color}`,
    border:` ${coursePageObject?.targetAudience?.border?.borderWidth?.value+coursePageObject?.targetAudience?.border?.borderWidth?.resolution} ${coursePageObject?.targetAudience?.border?.borderType}  ${coursePageObject?.targetAudience?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.targetAudience?.borderRadius?.topLeft?.value}${coursePageObject?.targetAudience?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.targetAudience?.borderRadius?.topRight?.value}${coursePageObject?.targetAudience?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.targetAudience?.borderRadius?.bottomLeft?.value}${coursePageObject?.targetAudience?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.targetAudience?.borderRadius?.bottomRight?.value}${coursePageObject?.targetAudience?.borderRadius?.bottomRight?.resolution}`,
}}>
<div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",}}>

</div>

<div className=" gridForCoursePageFiftyFifty"  style={{marginTop:"20px",overflow:"hidden",
    minHeight:"190px",position:"relative"}}>

<div className=" " style={{marginBottom:"20px"}}>
<div className="themeCoursePage courseContentTitleFontCoursePage coursePageTitleFont"
style={{color:coursePageObject?.targetAudience?.textColor?.color}}>Target Audience</div>
      <div  className="courseWhatWillearnIcon">
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.targetAudience?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",fontWeight:"500",color:coursePageObject?.targetAudience?.subTextColor?.color}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon">
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.targetAudience?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",fontWeight:"500",color:coursePageObject?.targetAudience?.subTextColor?.color}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon">
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.targetAudience?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",fontWeight:"500",color:coursePageObject?.targetAudience?.subTextColor?.color}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div>
</div>

<div className="" style={{ background:`${coursePageObject?.prerequisite?.bgColor?.color}`,
    border:` ${coursePageObject?.prerequisite?.border?.borderWidth?.value+coursePageObject?.prerequisite?.border?.borderWidth?.resolution} ${coursePageObject?.prerequisite?.border?.borderType}  ${coursePageObject?.prerequisite?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.prerequisite?.borderRadius?.topLeft?.value}${coursePageObject?.prerequisite?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.prerequisite?.borderRadius?.topRight?.value}${coursePageObject?.prerequisite?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.prerequisite?.borderRadius?.bottomLeft?.value}${coursePageObject?.prerequisite?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.prerequisite?.borderRadius?.bottomRight?.value}${coursePageObject?.prerequisite?.borderRadius?.bottomRight?.resolution}`,
position:"relative",marginBottom:"10px"}} >
   
<div className="themeCoursePage courseContentTitleFontCoursePage coursePageTitleFont" style={{color:coursePageObject?.prerequisite?.textColor?.color}}>Prerequisite</div>
 
    
  
  <div className=" " style={{
    padding:"10px",marginTop:"5px"}}>
    
    <div   className="courseWhatWillearnIcon ">
        <LayoutPanelLeft   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.prerequisite?.iconColor?.color}/> 
        <div className="themeCoursePage coursePageSubTitleFont "
   style={{fontSize:"14px",fontWeight:"500",color:coursePageObject?.prerequisite?.subTextColor?.color}}> 
     This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
   
        </div>
        </div><div   className="courseWhatWillearnIcon ">
        <LayoutPanelLeft   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.prerequisite?.iconColor?.color}/> 
        <div className="themeCoursePage coursePageSubTitleFont "
   style={{fontSize:"14px",fontWeight:"500",color:coursePageObject?.prerequisite?.subTextColor?.color}}> 
     This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
   
        </div>
        </div>
  </div>
  
  
  
    
    </div>

  
    </div> 
    <div className=""  style={{marginTop:"40px",paddingTop:"40px",paddingBottom:"40px",background:`${coursePageObject?.highlights?.bgColor?.color}`,
    border:` ${coursePageObject?.highlights?.border?.borderWidth?.value+coursePageObject?.highlights?.border?.borderWidth?.resolution} ${coursePageObject?.highlights?.border?.borderType}  ${coursePageObject?.highlights?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.highlights?.borderRadius?.topLeft?.value}${coursePageObject?.highlights?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.highlights?.borderRadius?.topRight?.value}${coursePageObject?.highlights?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.highlights?.borderRadius?.bottomLeft?.value}${coursePageObject?.highlights?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.highlights?.borderRadius?.bottomRight?.value}${coursePageObject?.highlights?.borderRadius?.bottomRight?.resolution}`,
position:"relative"}}>
 <div className="themeCoursePage   coursePageTitleFont"  style={{ fontSize:"28px",display:"flex",justifyContent:"left",gap:"10px",
  fontWeight:"700",margin:"3px",color:coursePageObject?.highlights?.textColor?.color}}>
  
  <BellElectric  strokeWidth={4} absoluteStrokeWidth  size={47} style={{marginTop:"-10px"}} color={coursePageObject?.highlights?.icon2Color?.color} />
  
  Highlights
  </div>
  

<div className="themeCoursePage courseWhatWillearnTextCoursePage" style={{
  marginTop:"5px"}}>
  
      <div   className="courseWhatWillearnIcon "style={{background:coursePageObject?.highlights?.iconBgColor?.color,margin:"10px",marginTop:"20px",padding:"10px",borderRadius:"15px"}}>
      <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.highlights?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont "
 style={{fontSize:"14px",color:coursePageObject?.highlights?.subTextColor?.color,fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon"style={{background:coursePageObject?.highlights?.iconBgColor?.color,margin:"10px",marginTop:"20px",padding:"10px",borderRadius:"15px"}}>
      <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.highlights?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont "
 style={{fontSize:"14px",color:coursePageObject?.highlights?.subTextColor?.color,fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div><div  className="courseWhatWillearnIcon"style={{background:coursePageObject?.highlights?.iconBgColor?.color,margin:"10px",marginTop:"20px",padding:"10px",borderRadius:"15px"}}>
      <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.highlights?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont "
 style={{fontSize:"14px",color:coursePageObject?.highlights?.subTextColor?.color,fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
      </div>
</div>



  
  </div>
    </div> 









 

   
  



  <div className="themeCoursePage courseWhatWillearnTextCoursePage"  style={{marginTop:"50px",
 position:"relative",display:"flex",justifyContent:"center"}}>
  <div style={{background:"#ffffff",  borderTopLeftRadius:`${coursePageObject?.giftCard?.borderRadius?.topLeft?.value}${coursePageObject?.giftCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.giftCard?.borderRadius?.topRight?.value}${coursePageObject?.giftCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.giftCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.giftCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.giftCard?.borderRadius?.bottomRight?.value}${coursePageObject?.giftCard?.borderRadius?.bottomRight?.resolution}`,
}}>
  <div style={{maxWidth:"300px",borderRadius:"15px",padding:"10px",margin:"5px" ,background:`${coursePageObject?.giftCard?.bgColor?.color}`,
    border:` ${coursePageObject?.giftCard?.border?.borderWidth?.value+coursePageObject?.giftCard?.border?.borderWidth?.resolution} ${coursePageObject?.giftCard?.border?.borderType}  ${coursePageObject?.giftCard?.border?.borderColor?.color}`,
    borderTopLeftRadius:`${coursePageObject?.giftCard?.borderRadius?.topLeft?.value}${coursePageObject?.giftCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.giftCard?.borderRadius?.topRight?.value}${coursePageObject?.giftCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.giftCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.giftCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.giftCard?.borderRadius?.bottomRight?.value}${coursePageObject?.giftCard?.borderRadius?.bottomRight?.resolution}`,
}} >
  <div className="themeCoursePage grid2080CoursePage"  style={{
  borderRadius:"25px",margin:"3px"}}>
  <div style={{background:coursePageObject?.giftCard?.iconBgColor?.color,width:"56px",height:"56px",borderRadius:"50%",padding:"0px"}} >
  <ShoppingBag strokeWidth={4} absoluteStrokeWidth  size={40} style={{margin:"8px",marginTop:"10px"}} color={coursePageObject?.giftCard?.iconColor?.color} />  </div>
  <div   >
  </div></div>
<div><div   >
    <div className="themeCoursePage coursePageHeaderFont"   style={{margin:"0px",fontSize:"26px",color:coursePageObject?.giftCard?.iconBgColor?.color,fontWeight:"800"}}>Gift this course</div>
  <div className="themeCoursePage  coursePageTitleFont"  style={{marginTop:"-13px",fontSize:"16px",color:coursePageObject?.giftCard?.textColor?.color,fontWeight:"600"}}
  >Gift this course to your friends</div>
  
  <div className="themeCoursePage coursePageSubTitleFont"  style={{marginTop:"-13px",fontSize:"12px",color:coursePageObject?.giftCard?.subTextColor?.color,fontWeight:"500"}}
  >Now You Can Gift This Course To Your Friend, So That Friendship Lives Longer</div>
  </div>
  <div className="themeCoursePage grid2080CoursePage"  style={{
  
 margin:"13px",height:"44px",background:`${coursePageObject?.giftCardButton?.bgColor?.color}`,
    border:` ${coursePageObject?.giftCardButton?.border?.borderWidth?.value+coursePageObject?.giftCardButton?.border?.borderWidth?.resolution} ${coursePageObject?.giftCardButton?.border?.borderType}  ${coursePageObject?.giftCardButton?.border?.borderColor?.color}`,
    borderTopLeftRadius:`${coursePageObject?.giftCardButton?.borderRadius?.topLeft?.value}${coursePageObject?.giftCardButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.giftCardButton?.borderRadius?.topRight?.value}${coursePageObject?.giftCardButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.giftCardButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.giftCardButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.giftCardButton?.borderRadius?.bottomRight?.value}${coursePageObject?.giftCardButton?.borderRadius?.bottomRight?.resolution}`,
}}>
  <div style={{background:coursePageObject?.giftCardButton?.iconBgColor?.color,width:"50px",height:"50px",borderRadius:"50%",padding:"0px"}} >
  <Gift strokeWidth={2} absoluteStrokeWidth  size={27} style={{margin:"11px"}} color={coursePageObject?.giftCardButton?.iconColor?.color} />  </div>
  <div   >
    <div className="themeCoursePage coursePageButtonFont"   style={{margin:"10px",fontSize:"19px",color:coursePageObject?.giftCardButton?.textColor?.color,fontWeight:"900"}}>Send As Gift</div>
  <div className="themeCoursePage"  style={{marginTop:"-13px",fontSize:"12px",color:"#bbb",fontWeight:"500"}}
  ></div></div></div>

    </div>
  </div></div>
 
</div>





<div className="themeCoursePage"  style={{marginTop:"50px",overflow:"hidden",
  minHeight:"190px",position:"relative",background:`${coursePageObject?.faqOuterCard?.bgColor?.color}`,
    border:` ${coursePageObject?.faqOuterCard?.border?.borderWidth?.value+coursePageObject?.faqOuterCard?.border?.borderWidth?.resolution} ${coursePageObject?.faqOuterCard?.border?.borderType}  ${coursePageObject?.faqOuterCard?.border?.borderColor?.color}`,
    borderTopLeftRadius:`${coursePageObject?.faqOuterCard?.borderRadius?.topLeft?.value}${coursePageObject?.faqOuterCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.faqOuterCard?.borderRadius?.topRight?.value}${coursePageObject?.faqOuterCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.faqOuterCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.faqOuterCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.faqOuterCard?.borderRadius?.bottomRight?.value}${coursePageObject?.faqOuterCard?.borderRadius?.bottomRight?.resolution}`,
}}>
<div className="themeCoursePage FAQGridTitleCoursePage FAOuterTitleCoursePage  coursePageHeaderFont"  style={{
  borderRadius:"25px",marginTop:"10px",fontWeight:"900",color:coursePageObject?.faqOuterCard?.textColor?.color}}>
   <div style={{marginTop:"-10px",background:coursePageObject?.faqOuterCard?.iconBgColor?.color,width:"60px",height:"60px",borderRadius:"50%",display:"flex",justifyContent:"center",alignItems:"center"}} >

  <BotMessageSquare   strokeWidth={4} absoluteStrokeWidth  size={47}  color={coursePageObject?.faqOuterCard?.iconColor?.color} />
  </div>
  FAQs
  </div>

<div className=" ">
  
<div className="FAQShadowCoursePage" style={{ borderTopLeftRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.topLeft?.value}${coursePageObject?.faqInnerCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.topRight?.value}${coursePageObject?.faqInnerCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.faqInnerCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.bottomRight?.value}${coursePageObject?.faqInnerCard?.borderRadius?.bottomRight?.resolution}`,
}}>
<div  className="FAQActiveCoursePage" style={{background:`${coursePageObject?.faqInnerCard?.bgColor?.color}`,
    border:` ${coursePageObject?.faqInnerCard?.border?.borderWidth?.value+coursePageObject?.faqInnerCard?.border?.borderWidth?.resolution} ${coursePageObject?.faqInnerCard?.border?.borderType}  ${coursePageObject?.faqInnerCard?.border?.borderColor?.color}`,
    borderTopLeftRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.topLeft?.value}${coursePageObject?.faqInnerCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.topRight?.value}${coursePageObject?.faqInnerCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.faqInnerCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.bottomRight?.value}${coursePageObject?.faqInnerCard?.borderRadius?.bottomRight?.resolution}`,
}} >
        <div className="themeCoursePage FAQQuestionStyleCoursePage coursePageTitleFont"
        style={{color:`${coursePageObject?.faqInnerCard?.textColor?.color}`}}  > 
 FAQ 1:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div> 
      <div style={{background:`${coursePageObject?.faqInnerCard?.bg2Color?.color}`,width:"40px",height:"40px",borderRadius:"50%"}}><Minus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> </div>
      </div>

      
      <div  className="FAQItemInnerCoursePage">
      <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont "
 style={{fontSize:"13px",color:`${coursePageObject?.faqInnerCard?.subTextColor?.color}`,fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests 
 
      </div>
      </div>
      <div  className="FAQItemInnerCoursePage">
      <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"13px",color:`${coursePageObject?.faqInnerCard?.subTextColor?.color}`,fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
  This Course Includes Hands On Exercises Videos And Tests 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div>
      <div  className="FAQItemInnerCoursePage">
      <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"13px",color:`${coursePageObject?.faqInnerCard?.subTextColor?.color}`,fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
      </div>
      </div>


<div className="FAQShadowCoursePage">
      <div  className="FAQInActiveCoursePage">
        <div className="themeCoursePage FAQQuestionStyleCoursePage coursePageTitleFont"
 style={{color:`${coursePageObject?.faqInnerCard?.textColor?.color}`}} > 
 FAQ 2:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div> 
      <div style={{background:`${coursePageObject?.faqInnerCard?.bgColor?.color}`,width:"40px",height:"40px",borderRadius:"50%"}}><Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> </div>
    
     
      </div>
     
</div>
      
<div className="FAQShadowCoursePage">
      <div  className="FAQInActiveCoursePage">
        <div className="themeCoursePage FAQQuestionStyleCoursePage coursePageTitleFont"
 style={{color:`${coursePageObject?.faqInnerCard?.textColor?.color}`}} > 
 FAQ 3:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div>
       <div style={{background:coursePageObject?.faqInnerCard?.bgColor?.color,width:"40px",height:"40px",borderRadius:"50%"}}><Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> </div>
    
     
      </div>
     
</div>
<div className="FAQShadowCoursePage">
      <div  className="FAQInActiveCoursePage">
        <div className="themeCoursePage FAQQuestionStyleCoursePage coursePageTitleFont"
 style={{color:`${coursePageObject?.faqInnerCard?.textColor?.color}`}} > 
 FAQ 4:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div> 
      <div style={{background:coursePageObject?.faqInnerCard?.bgColor?.color,width:"40px",height:"40px",borderRadius:"50%"}}><Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> </div>
    
     
      </div>
     
</div>

</div>

  </div>


</div>
<div>
</div>
</div>:"Please Add Name And Course Details To See Preview"}
<div ref={bottomDivRef} ></div>
<div style={{ height: "500px" ,}} ></div>  





  


   </div>
   
	  </div> 
<style>{`
.coursePageHeaderFont{
  font-family:${coursePageObject?.titleFonts?.headerFont?.family?.fontFamily};;
}

.coursePageTitleFont{
  font-family:${coursePageObject?.titleFonts?.titleFont?.family?.fontFamily};;
}
.coursePageSubTitleFont{
  font-family:${coursePageObject?.titleFonts?.subtitleFont?.family?.fontFamily};;
}
  .coursePageTagsFont{
  font-family:${coursePageObject?.titleFonts?.tagsFont?.family?.fontFamily};;
}.coursePageButtonFont{
  font-family:${coursePageObject?.titleFonts?.buttonFont?.family?.fontFamily};;
}  .shareWishlistTextCoursePage{display:none }

   .themeCoursePage{
       padding:15px !important;padding-top:5px !important
    }
.courseCourseCardlOuterGrid{
  display:grid;
  grid-template-columns:  420px auto 5%;
}
        .normal-div-last-courseCard1{
        width: 380px; 
        position: absolute;;
      bottom:0px ;
        visibility:visible;left:30px !important;
        overflow: hidden;overflow-y: auto !important;
        color:#9690da;;background: #fff;
        font-size: 20px;
           font-weight: 900;text-align: center;
           margin:0px;
         z-index: 999;
           border-radius: 45px;;  box-shadow: 0 7px 20px 0 rgba(48, 25, 131, 0.13);
      }

        .fixed-div-courseCard1 {  width: 380px;
          position: fixed;background: #fff;
          top: 0vh !important;
          visibility:visible;left:30px ;
          overflow: hidden;
          color:#9690da;
            font-size: 20px;
             font-weight: 900;text-align: center;
             margin:0px;
             z-index: 999;
             border-radius: 45px;;  box-shadow: 0 7px 20px 0 rgba(48, 25, 131, 0.13);
             transition: width 0.9s ease;
        }

          .product-tag-themeCoursePage {
          
    background: ${coursePageObject?.sidebarStatusTag?.bgColor?.color};;
    opacity: 1;text-align: left;
    display: inline-block;
    position: relative;
    top: 35px;
   border:  ${coursePageObject?.sidebarStatusTag?.border?.borderWidth?.value+coursePageObject?.sidebarStatusTag?.border?.borderWidth?.resolution} ${coursePageObject?.sidebarStatusTag?.border?.borderType}  ${coursePageObject?.sidebarStatusTag?.border?.borderColor?.color};
  border-top-left-radius:${coursePageObject?.border?.borderRadius?.topLeft?.value}${coursePageObject?.border?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${coursePageObject?.border?.borderRadius?.topRight?.value}${coursePageObject?.border?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${coursePageObject?.border?.borderRadius?.bottomLeft?.value}${coursePageObject?.border?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${coursePageObject?.border?.borderRadius?.bottomRight?.value}${coursePageObject?.border?.borderRadius?.bottomRight?.resolution};
        
    
  
   left: 0px;
    text-transform: uppercase;
    color: ${coursePageObject?.sidebarStatusTag?.textColor?.color};
    font-size: 13px;
    font-weight: 700;
    z-index: 1;
    padding: 2px 10px;
    z-index: 999;
    line-height: 20px
}
     
.catUndrlineCoursePage{text-decoration: underline; font-size: 18px;font-weight: 600;;}
.coursePageWhatsIncluded{display:flex;flex-direction:row}

.product-tag-themeCoursePage:after {
    content: "";
    position: absolute;
    border-color:  ${coursePageObject?.sidebarStatusTag?.border?.borderColor?.color} transparent  ${coursePageObject?.sidebarStatusTag?.border?.borderColor?.color}  ${coursePageObject?.sidebarStatusTag?.border?.borderColor?.color};
    border-style: solid;
    border-width: 10px;
    left: 100%;
    width: 0;
    height: 0;
    top: 2px;
}



  .scroller-wrapperCoursePage {
    display: flex;
    align-items: center;
    position: relative;
    position: absolute;left:0px;right:0px;
    
    margin: auto;
  }
  
  .scrollerCoursePage {
    display: flex;
    gap: 10px;
    overflow: hidden;
    scroll-behavior: smooth;
    white-space: nowrap;
    width: 100%;
    padding: 10px 0;
  }
  
  
  
  .scroll-btnCoursePage {
    background-color: #2c3e50;
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    font-size: 18px;
    border-radius: 5px;
  }
  
  .scroll-btnCoursePage:hover {
    background-color: #1a252f;
  }
  
  .left {
    margin-right: 5px;
  }
  
  .right {
    margin-left: 5px;
  }

  .courseWhatWillearnTextCoursePage{
  
  display:grid; margin-top: 30px;
  grid-template-columns:  50% 50%;
}
   .courseContentTitleFontCoursePage{ margin-top:30px;
    font-size: 25px;font-weight: 600;padding: 19px;
  }
    .courseContentTitleFontTwoCoursePage{margin-top:35px;
    font-size: 35px;font-weight: 600;padding: 19px;}
 .gridForCoursePageFiftyFifty{
        display:grid;gap:10px;
    grid-template-columns:50% 50% ;
    }
    
.grid2080CoursePage{ display:grid;
  grid-template-columns: 15% 85%;}

  
.FAQShadowCoursePage{border-radius: 15px;padding:0px ;margin-top: 20px !important;
    box-shadow: 0 7px 20px 0 rgba(48, 25, 131, 0.053);overflow: hidden;}

.FAOuterTitleCoursePage{display:grid; margin-top: 0px;padding: 10px;
  grid-template-columns:  10% auto;font-size: 34px;}

  .FAQGridTitleCoursePage{
  display:grid; margin-top: 0px;padding: 10px;
  grid-template-columns:  10% auto;
}
  .FAQActiveCoursePage{
  display:grid; margin-top: 0px;margin-bottom: 10px;background: rgba(255,114,94,0.1) ;;
  grid-template-columns:   auto  8%;padding: 5px; padding-top: 15px; border-radius: 0px;
}

.FAQInActiveCoursePage{
  display:grid; margin-top: 0px;margin-bottom: 10px;
  grid-template-columns:   auto  8%;padding: 5px; padding-top: 15px; border-radius: 0px;
}

.FAQQuestionStyleCoursePage{
  font-size:16px;color:#555;font-weight:700;
}
  .FAQItemInnerCoursePage{
  
  display:grid; margin-top: 5px;
  grid-template-columns:  5% auto ;padding: 5px;
}
 /* md */
   @media (min-width: 992px) and (max-width: 1199px) {
   .courseCourseCardlOuterGrid{
 
  grid-template-columns:  300px 65%  !important;
}
  .normal-div-last-courseCard1{
       width: 280px;left:10px !important;
}
  .fixed-div-courseCard1{
    width: 280px;left:20px !important; }
  
 
}


 /* sm */
      @media (min-width: 768px) and (max-width: 991px) {
      .gridForCoursePageFiftyFifty{  margin-left: 5%; grid-template-columns:  90%;}
    .courseCourseCardlOuterGrid{
 
        grid-template-columns:  auto  !important;
      }
        .normal-div-last-courseCard1,.fixed-div-courseCard1 {
    position: relative !important; top: 0vh !important;
    right:0px !important;width: 100% !important;
     left:0px !important;
  }
  
}

/* xs */
  @media (max-width: 767px) {
 .gridForCoursePageFiftyFifty {
        margin-left: 0%;
        grid-template-columns:  100%  ;}
  .coursePageWhatsIncluded{display:flex;flex-direction:column !important}

   .shareWishlistTextCoursePage,.BottomCardXsCourse{display:block !important}
   .courseCourseCardlOuterGrid{
   
    grid-template-columns: 100% !important;
  }   
    
.normal-div-last-courseCard1{
       
  position: relative !important;
  right:0px !important; left:0px !important;
  width: 100% !important
}
  .fixed-div-courseCard1 {
    position: relative !important; top: 0vh !important;
    right:0px !important;width: 100% !important;
    height:100%;; left:0px !important;
  } .courseWhatWillearnTextCoursePage{
    display: grid !important;
    grid-template-columns:100% !important;; /* Two columns of equal width */
    grid-auto-rows: auto; /* Automatic row heights */
    
  }
    .courseContentTitleFontTwoCoursePage{margin-top:20px;
    font-size: 25px;font-weight: 600;padding: 19px;}
.FAOuterTitleCoursePage{
  font-size: 26px;
  grid-template-columns:  20% auto;
}
  .FAQGridTitleCoursePage{
  
  grid-template-columns:  20% auto;
}
  .FAQInActiveCoursePage,.FAQActiveCoursePage{
 
  grid-template-columns:   auto  12%;
}
    
}

`}</style>
    </>
                            
   )  
   }
   export default CoursePageCard;